import { inject } from '@angular/core';

import { map, take } from 'rxjs';

import { isOnFreePlan } from '@shared/user/functions';
import { AuthRestaurantService } from '@tablesready/frontend-store';
import { FreePlanLocationModalService } from '../services';

export const freePlanGuard = () => {
  const authRestaurantService = inject(AuthRestaurantService);
  const freePlanLocationModalService = inject(FreePlanLocationModalService);

  const user = authRestaurantService.get();
  const isLocationOnFreePlan = isOnFreePlan(user);

  if (isLocationOnFreePlan) {
    return freePlanLocationModalService.display(user).pipe(
      take(1),
      map(() => false),
    );
  }

  return true;
};
